import ERROR_ICON from '@assets/icons/mStock/error.svg'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export const MStockErrorUI = ({
  title = '일시적인 오류가 발생했습니다.\n잠시 후 다시 이용해 주세요.',
  buttonLabel = '다시 조회하기',
  handleClick,
  className = ''
}) => {
  const { t } = useTranslation()
  return (
    <article
      className={clsx(
        'bg-m-surface-page flex min-h-[242px] flex-col items-center gap-16 py-[56px] text-center',
        className
      )}
    >
      <img src={ERROR_ICON} alt={t('common.errorAlt')} width={120} height={120} decoding="async" />
      <div className="flex flex-col gap-24">
        <h2 className={'text-m-content-primary text-14 font-normal whitespace-pre-line'}>
          {title}
        </h2>
        {handleClick && (
          <button
            type="button"
            className="border-m-stroke-normal bg-m-error-action-surface text-14 rounded-12 text-m-content-secondary w-fit self-center border px-16 py-8"
            onClick={handleClick}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </article>
  )
}
